import { ofType } from "redux-observable";
import * as Rx from "rxjs";
import * as RxOp from "rxjs/operators";
import * as S from "sanctuary";
import { getPaymentReceipt } from "@/APIClient";
import {
  REQUEST_DOWNLOAD_RECEIPT,
  downloadReceiptStarted,
  downloadReceiptFinished,
  paymentPageAlertBarAction,
} from "../Payment.state";
import { requestEpic } from "@/APIClient/observable.util";
import { addAlert, clearAlerts } from "@/components/alert-bar/AlertBar.state";
import { getAuthToken } from "@/util/session";
import { printHtmlDocument } from "@/util/receipt";

const receiptFailedAlert = (transactionId, err) =>
  paymentPageAlertBarAction(
    addAlert({
      heading: "Receipt Unavailable",
      text:
        err?.body?.detail ??
        `The receipt for transaction ${transactionId} could not be downloaded.`,
      variant: "error",
    })
  );

const downloadReceiptEpic = (action$) =>
  action$.pipe(
    ofType(REQUEST_DOWNLOAD_RECEIPT),
    RxOp.exhaustMap(({ payload: { transactionId } }) =>
      Rx.concat(
        Rx.of(downloadReceiptStarted(), paymentPageAlertBarAction(clearAlerts())),
        requestEpic({
          requestMethod: getPaymentReceipt,
          requestArgs: {
            id: transactionId,
            token: S.fromMaybe("")(getAuthToken()),
          },
          onSuccess: ({ value: { data } }) =>
            Rx.from(printHtmlDocument({ title: data.title, html: data.html })).pipe(
              RxOp.map(() => downloadReceiptFinished())
            ),
          onFailure: ({ value: err }) =>
            Rx.of(downloadReceiptFinished(), receiptFailedAlert(transactionId, err)),
        })
      ).pipe(
        // Inside exhaustMap so one failed download does not stop later ones.
        RxOp.catchError(() =>
          Rx.of(downloadReceiptFinished(), receiptFailedAlert(transactionId))
        )
      )
    )
  );

export default downloadReceiptEpic;
